import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { getWhatsAppFlowListCacheKey } from "./constants";
import type { WhatsAppListFlowsResponse } from "./types";

export const getWhatsAppFlowList = reactQueryFetcherAdapter(
  getWhatsAppFlowListCacheKey,
  async (signal, appGroupId: string, messagingServiceId: string): Promise<WhatsAppListFlowsResponse> => {
    return await fetch(
      `/engagement/${appGroupId}/whatsapp/flows/${messagingServiceId}`,
      "GET",
      undefined,
      {
        signal,
      },
      { propagateFetchRequestError: false }
    );
  }
);
